import { render, staticRenderFns } from "./form-component-fileinput.vue?vue&type=template&id=5e567bda&scoped=true"
import script from "./form-component-fileinput.vue?vue&type=script&lang=ts"
export * from "./form-component-fileinput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e567bda",
  null
  
)

export default component.exports